import React, { useEffect, useState } from "react";
import { Col, Row, Tab } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import NavTabs from "./view-data/nav-tabs";
import RawData from "./view-data/raw-data";
import TransformData from "./view-data/transform-data";
import TransformFinal from "./view-data/transform-final";
import RawXml from "./view-data/raw-xml";
import { EstablishmentDataType } from "../../app/enums";

function getRequestedDataView(search: string): EstablishmentDataType {
    return new URLSearchParams(search).get("data") === "final"
        ? EstablishmentDataType.TransformFinal
        : EstablishmentDataType.RowXML;
}

export default function EstablishmentData(props: any) {
    const location = useLocation();
    const requestedDataView = getRequestedDataView(location.search);
    const [activeKey, setActiveKey] = useState(requestedDataView);
    const personSearch = new URLSearchParams(location.search).get("person") ?? "";

    useEffect(() => {
        setActiveKey(requestedDataView);
    }, [requestedDataView]);

    function callbackActiveTab(selectedKey: string | null) {
        if (selectedKey) {
            setActiveKey(selectedKey as EstablishmentDataType);
        }
    }

    return (
        <div className="mt-1">
            <Tab.Container activeKey={activeKey} id="establishment-people-data">
                <Row className="people-data">
                    <Col sm={12}>
                        <NavTabs activeKey={activeKey} callbackActiveTab={callbackActiveTab} />
                    </Col>
                </Row>
                <Row className="mt-1">
                    <Col sm={12}>
                        <Tab.Content>
                            <Tab.Pane eventKey={activeKey}>
                                {activeKey === EstablishmentDataType.RowXML && <RawXml />}
                                {activeKey === EstablishmentDataType.RowData && <RawData />}
                                {activeKey === EstablishmentDataType.Transform && <TransformData />}
                                {activeKey === EstablishmentDataType.TransformFinal && (
                                    <TransformFinal
                                        establishmentName={props.establishmentName}
                                        initialSearch={personSearch}
                                    />
                                )}
                            </Tab.Pane>
                        </Tab.Content>
                    </Col>
                </Row>
            </Tab.Container>
        </div>

    );
}